<template>
  <component :is="$snippets[layoutComponent]" />
</template>

<script>
import context from '@/context'
import loadDirectives from '../directives'
import '../store'
import { loadIcons } from 'nette-base-module/js/components/AwIcon'
import loadComponents from '../components'
//import { loadIcons } from 'nette-base-module/js/components/AwIcon'
// import store from '../store'
import './index'

export default {
  name: 'Layout',
  setup() {
    loadDirectives(context.vueApp, context)

    // load icons
    loadIcons(
      require.context(
        // root folder for components
        '!raw-loader!../svg/',
        // recursive
        false,
        // include all .js wo index.js
        /\.svg$/
      )
    )
    loadComponents(context.vueApp, context)
  },
  data() {
    return {
      layoutComponent: context.rootElementId
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../scss/screen.scss';
</style>
